<template>
    <div class="pd-12 top-border-bottom">
        <a class="exch-breadcrumb-heading-sec" @click="$router.go(-1)">
            <img  src="@/assets/images/back.webp" alt="back" >
            <h5 class="text-capitalize">Withdraw</h5>
        </a>
    </div>
    <div class="exch-deposit-wrapper">
        <div class="mr-row-sec">
            <div class="multiSteps-container multiSteps-withdraw">
                <div class="multiSteps-points">
                    <div class="points-circle active">1</div>
                    <div class="points-border"></div>
                    <div class="points-circle">2</div>
                </div>
                <div class="multiSteps-name">
                    <div class="title-wrap active">{{ $t('enter-amt', 'Enter amount') }}</div>
                    <div class="title-wrap">{{ $t('select-account', 'Select Account') }}</div>
                </div>
            </div>
            <div class="exch-payment-step-content-wrapper">
                <div class="wallet-list-wrapper">
                    <div class="exch-deposit-amount-sec-step-1">
                        <div class="walletMain-balance" v-if="$auth.user">
                            <span class="walletMain-star1">
                                <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute top-1 left-1 w-6 h-6" opacity="0.73">
                                    <path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path>
                                </svg>
                            </span>
                            <span class="walletMain-star2">
                                <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute top-[0.2rem] right-[0.1rem] w-6 h-6" opacity="0.73">
                                    <path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path>
                                </svg>
                            </span>
                            <span class="walletMain-star3">
                                <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="top-[85%] right-[50%] -translate-x-1/2 -translate-y-1/2 absolute" opacity="0.73">
                                    <path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path>
                                </svg>
                            </span>
                            <span class="walletMain-wallet">
                                <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-10 h-10 absolute left-[7.6875rem] top-[0.25rem]">
                                    <path id="Vector" d="M7 -1C7 -1.55228 7.44772 -2 8 -2H16C16.5523 -2 17 -1.55228 17 -1V2H7V-1Z" fill="#fff" fill-opacity="0.2"></path>
                                    <path id="Vector_2" fill-rule="evenodd" clip-rule="evenodd" d="M3 7C3 5.34315 4.34315 4 6 4H18C19.6569 4 21 5.34315 21 7V15C21 16.6569 19.6569 18 18 18H6C4.34315 18 3 16.6569 3 15V7ZM19 14V8H15C14.4477 8 14 8.4477 14 9V13C14 13.5523 14.4477 14 15 14H19Z" fill="#fff" fill-opacity="0.2"></path>
                                    <path id="Vector_3" d="M16 12C16.5523 12 17 11.5523 17 11C17 10.4477 16.5523 10 16 10C15.4477 10 15 10.4477 15 11C15 11.5523 15.4477 12 16 12Z" fill="#fff" fill-opacity="0.2"></path>
                                </svg>
                            </span>
                            <span class="walletMain-style">
                                <svg width="90" height="74" viewBox="0 0 90 74" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute right-0 top-0 w-[6.25rem] h-full overflow-hidden">
                                    <g id="Frame" clip-path="url(#clip0_1619_42848)">
                                        <g mask="url(#mask0_1619_42848)">
                                            <path id="Vector_2" fill-rule="evenodd" clip-rule="evenodd" d="M0 -16.5H25V8.5H0V-16.5ZM50 8.5H25V33.5H0V58.5H25V83.5H50V58.5H75V83.5H100V58.5H75V33.5H100V8.5H75V-16.5H50V8.5ZM50 33.5H75V8.5H50V33.5ZM50 33.5V58.5H25V33.5H50Z" fill="url(#paint0_linear_1619_42848)" fill-opacity="0.05"></path>
                                        </g>
                                    </g>
                                    <defs>
                                        <linearGradient id="paint0_linear_1619_42848" x1="50" y1="-16.5" x2="50" y2="83.5" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#A7B5FF"></stop>
                                            <stop offset="1" stop-color="#F3ACFF"></stop>
                                        </linearGradient>
                                        <clipPath id="clip0_1619_42848">
                                            <rect width="90" height="74" fill="#fff" transform="translate(0 -16.5)"></rect>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            <img class="wallet3D-pic" srcset="@/assets/images/3D-wallet.svg" src="@/assets/images/3D-wallet.svg" alt="wallet" title="Withdraw Wallet" loading="lazy" width="78" height="74">
                            <div class="walletMain-content">
                                <span class="walletMain-title">{{ availableBalance }}</span>
                                <div class="walletMain-text-wrap">
                                    <span class="walletMain-text">{{ $t('main-wallet', 'Main Wallet') }}</span>
                                    <div class="walletMain-anytime">{{ $t('can-withdraw-anytime', 'Can Withdraw Anytime') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="deposit-amount-sec">
                            <div class="amount-field m-0 amount_filed_stake_val">
                                
                                <input type="text" class="form-control" :placeholder="$t('amount', 'Enter Amount')" v-model="amount"  @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.withdrawal_range?.max || 10000000)">
                                <div class="min_max_title mt-2">
                                        <span class="input-tag-right mt-0">
                                        {{ $t('min', 'Min') }}: {{ walletConfig?.withdrawal_range?.min ? +walletConfig?.withdrawal_range?.min : 100 }}
                                        </span>
                                        <span class="input-tag-right mt-0">
                                        {{ $t('max', 'Max') }}: {{ walletConfig?.withdrawal_range?.max ? +walletConfig?.withdrawal_range?.max : 10000000 }}
                                        </span>
                                </div>
                            </div>
                        </div>
                        <button class="green-theme-btn w-100" :disabled="amount < (Number(walletConfig?.withdrawal_range?.min) || 100)" @click="walletWithdrawSubmitBtn()">
                            {{ $t('continue-to-select-account', 'Continue To Select Account') }}
                        </button>
                    </div>
                </div>
            </div>
            <WalletInstructions walletType='withdrawal' />
            <TutorialVideo type = "3" v-if="Object.values(walletConfig?.withdrawal_video).some(val => val?.trim() !== '')"/>
		</div>
	</div>

</template>

<script>
import { defineAsyncComponent } from 'vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WalletInstructions from '../components/WalletInstructions.vue';
export default {
    name: "WalletWithdraw",
    inject: ['walletConfig'],
    data() {
        return {
            amount: null,
            loading: false,
            walletData: null,
        }
    },
    components:{
        TutorialVideo,
        WalletInstructions
    },
    mounted() {
        if(this.$auth.user.isDemo){
            this.$errorToast("Wallet access is restricted for demo user");
            setTimeout(() => {
                this.$router.push({name: 'Home'})
            }, 500);
        }
    },
    computed: {
        availableBalance() {
            return ((+this.$auth.user?.balance || 0) - (+this.$auth?.user?.earnBonus || 0) + parseInt(this.$auth.user?.expl || 0)).toFixed(2);
        }
    },
    methods: {
        setAmount(val){
            if(val > this.walletData?.range?.maximum_withdrawal){
                val = this.walletData?.range?.maximum_withdrawal;
            }
            this.amount = val;
        },
        userData() {
            return this.$store.getters.stateUser;
        },
        saveButtonClick(stakes) {
            this.walletData.stake = stakes;
        },
        walletWithdrawSubmitBtn() {
            if (this.amount == null || 
                this.amount < (!this.walletData?.range?.minimum_withdrawal ? 100 : this.walletData?.range?.minimum_withdrawal) || 
                this.amount > (!this.walletData?.range?.maximum_withdrawal ? 99999999 : this.walletData?.range?.maximum_withdrawal)) {
                    const minAmount = !this.walletData?.range?.minimum_withdrawal ? 100 : this.walletData?.range?.minimum_withdrawal;
                    const maxAmount = !this.walletData?.range?.maximum_withdrawal ? 99999999 : this.walletData?.range?.maximum_withdrawal;
                    this.$errorToast(`${this.$t('amount-should-be-in-between', 'Amount Should Be In Between')} ${minAmount} To ${maxAmount}.`);
            } else {
                this.goToPaymentMethod();
            }
        },
        goToPaymentMethod() {
            this.$store.dispatch('setWithdrawalAmount', this.amount);
            this.$router.push({ name: 'withdraw-select-account' });
        },
        resetStake() {
            this.$refs.resetStakeCall.resetChips();
        },
    }
}
</script>